import React from "react";

interface PriceDetailProps {
  label: string;
  value: string;
  info?: string;
  children?: React.ReactNode;
}

const PriceDetail: React.FC<PriceDetailProps> = ({
  label,
  value,
  children,
}) => {
  return (
    <div className="flex justify-between homepage-text-sm ">
      <div className="flex items-center gap-1">
        <span>{label}</span>
        {children}
      </div>
      <span className="homepage-text-sm ">{value}</span>
    </div>
  );
};

export default PriceDetail;
